import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";

export class BackgroundManager extends Phaser.Group {

    public static PENALTY = "penalty";

    private static PENALTY_BACKGROUND_SCALE = 1.65;

    public backgroundImage: Phaser.Image;

    private goalGlow: Phaser.Image;

    constructor(game: Phaser.Game, backgroundType?: string) {

        super(game, null, "background-manager", false);

        this.goalGlow = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, (1 - GameVars.scaleY * GameVars.fieldCorrectionScaleY) * GameConstants.GAME_HEIGHT / 2 + GameConstants.GAME_HEIGHT * GameVars.scaleY * GameVars.fieldCorrectionScaleY, "texture_atlas_1", "rays_goal");
        this.goalGlow.scale.set(2.25, 3.5);
        this.goalGlow.anchor.set(.5, 1.1);
        this.goalGlow.visible = false;

        this.backgroundImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "lawn-background");
        this.backgroundImage.anchor.set(.5);
        this.backgroundImage.scale.y = GameVars.scaleY * GameVars.fieldCorrectionScaleY;

        if (backgroundType === BackgroundManager.PENALTY) {

            this.backgroundImage.scale.setTo(BackgroundManager.PENALTY_BACKGROUND_SCALE, BackgroundManager.PENALTY_BACKGROUND_SCALE);

            this.backgroundImage.anchor.setTo(.5, .865);
            this.backgroundImage.y = 830;

            this.goalGlow.y = 830;
        }

        this.add(this.backgroundImage);
        this.add(this.goalGlow);
    }

    public pulseBackgroundAlpha(): void {

        if (this.backgroundImage.alpha === 1) {
            this.backgroundImage.alpha = .8;
        } else {
            this.backgroundImage.alpha = 1;
        }
    }

    public onGoal(): void {

        this.goalGlow.visible = true;

        this.game.add.tween(this.goalGlow).to({ alpha: 0 }, 600, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(this.removeGoalGlow, this);
    }

    public onVoodoo(): void {

        this.game.time.events.add(400, this.illuminate, this);
    }

    private removeGoalGlow(): void {

        this.goalGlow.visible = false;
        this.goalGlow.alpha = 1;
    }

    private illuminate(): void {

        this.backgroundImage.blendMode = 2;
        this.game.time.events.add(150, this.resetBackground, this);
    }

    private resetBackground(): void {

        this.backgroundImage.blendMode = 0;
    }
}
